export type TerragruntResourceTypes = 'unknown';
export type TerragruntDependencyTypes = 'unknown' | 'terraform';
